exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.inventory-list-item {\n  margin-bottom: 20px;\n  width: 100%;\n}\n.padging-container {\n  text-align: center;\n  padding: 25px;\n}\n.loader-container {\n  -ms-flex: 1;\n      flex: 1;\n  text-align: center;\n  padding-top: 15%;\n}\n.looping-rhombuses-spinner {\n  display: inline-block;\n}\n.back-link{\n  margin-bottom: 15px;\n  display: inline-block;\n}\n.back-link>.icon{\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-c78d3bc8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/inventory/specials.vue
// module id = 646
// module chunks = 0